import React, { FC } from 'react';
import { QRCodesView } from '../components';

export const QRCodesPage: FC = () => {
  return <QRCodesView />;
};


